import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconBrackets';
/** Renders an SVG icon. */
const SvgBrackets = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21.414 4.09a1 1 0 0 1 .496 1.324l-10 22a1 1 0 0 1-1.82-.828l10-22a1 1 0 0 1 1.324-.496M9.793 6.39a1 1 0 0 1-.183 1.403L4.14 12l5.47 4.208a1 1 0 1 1-1.22 1.585l-6.5-5a1 1 0 0 1 0-1.585l6.5-5a1 1 0 0 1 1.403.183Zm12.414 8a1 1 0 0 1 1.403-.182l6.5 5a1 1 0 0 1 0 1.585l-6.5 5a1 1 0 0 1-1.22-1.585L27.86 20l-5.47-4.207a1 1 0 0 1-.183-1.402Z"
      />
    </svg>
  );
};
SvgBrackets.displayName = displayName;
export default SvgBrackets;
